import { hasCapability, type User } from "../base";

export const contractorProfile = {
  read: (user: User, contractorId?: string) => {
    if (hasCapability(user, "contractorProfile.read.all")) {
      return true;
    }
    return user.person.organizationId === contractorId && hasCapability(user, "contractorProfile.read.org");
  },
  readAll: (user: User) => hasCapability(user, "contractorProfile.read.all"),
  create: (user: User) => hasCapability(user, "contractorProfile.create"),
  update: (user: User, contractorId?: string) => {
    if (hasCapability(user, "contractorProfile.update.all")) {
      return true;
    }
    return user.person.organizationId === contractorId && hasCapability(user, "contractorProfile.update.org");
  },
  updateAll: (user: User) => hasCapability(user, "contractorProfile.update.all"),
  activate: (user: User) => hasCapability(user, "contractorProfile.activate"),
  manageRoles: (user: User) => hasCapability(user, "contractorProfile.manageRoles"),
};

export const contractorInternalFields = {
  read: (user: User) => hasCapability(user, "contractorInternalFields.read"),
  update: (user: User) => hasCapability(user, "contractorInternalFields.update"),
};

export const contractorDocuments = {
  uploadCorrection: (user: User, contractorId?: string) => {
    if (!hasCapability(user, "contractorDocuments.uploadCorrection")) {
      return false;
    }
    if (hasCapability(user, "contractorInternalFields.update")) {
      return true;
    }
    return !!contractorId && user.person.organizationId === contractorId;
  },
};
